import { useGetShowcaseVideo } from './use-get-showcase-video';
import { useSelectedId } from './use-selected-id';

export const useLiveEventData = () => {
  const { selectedId } = useSelectedId();
  const { clip } = useGetShowcaseVideo(selectedId);

  const eventId = clip?.eventId;
  const eventHash = clip?.live?.recurringEvent?.streamPrivacy?.unlistedHash;
  const liveStatus = clip?.live?.status;
  const chatEnabled = clip?.live?.recurringEvent?.chatEnabled;
  const hasRegistration = clip?.live?.recurringEvent?.hasRegistration;
  const associatedShowcaseId = clip?.live?.recurringEvent?.album?.id;

  return {
    associatedShowcaseId,
    eventId,
    eventHash,
    liveStatus,
    chatEnabled,
    hasRegistration,
  };
};
